// Local-mode mock for the operator picker (walletService/walletUserList).

const WALLET_USERS = [
  { walletId: 1, userId: 1, username: "John Doe", emailAddress: "guptasatyam1807@gmail.com", status: "Active" },
  { walletId: 2, userId: 2, username: "", emailAddress: "saffran@authnull.com", status: "Active" },
  { walletId: 3, userId: 3, username: "Sumit", emailAddress: "sumit@authnull.com", status: "Active" },
  { walletId: 4, userId: 4, username: "Aditya Dutta", emailAddress: "aditya@authnull.com", status: "ACTIVE" },
  { walletId: 5, userId: 5, username: "Former Contractor", emailAddress: "contractor@example.com", status: "Inactive" },
  { walletId: 6, userId: 6, username: "No Email", emailAddress: "", status: "Active" },
].map((u) => ({ walletUrl: "", walletKey: "", ...u }));

export const SUDO_MOCKS = [
  // The real list reads did.users: { code, status, count, users: [{ userId,
  // emailAddress, username, status, … }] }. The static "/walletuser" key
  // otherwise answers with no users, which the user pickers can't use.
  {
    pattern: "/walletservice/walletuserlist",
    respond: () => ({ code: 200, status: "success", message: "OK", count: WALLET_USERS.length, users: WALLET_USERS }),
  },
];
